import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../service/udnick';

export const CriarCadVeiculoService = {
  criaAlteraVeiculoPortal: (
    veiculo: {
      codParcTransp: number;
      placa: string;
      ano?: number;
    },
    parceiros: number[]
  ): Promise<AxiosResponse> =>
    UDNICK.callService('criaAlteraVeiculoPortal', { veiculo, parceiros }),
};

export const excluiVeiculoPortal = {
  excluiVeiculoPortal: (codVeiculo: number, parceiros: number[]): Promise<AxiosResponse> =>
    UDNICK.callService('excluiVeiculoPortal', { codVeiculo, parceiros }),
};

export const CadProprietarioVeiculoService = {
  criaParceiro: (parceiro: {
    nome: any;
    cnpjCpf: any;
    tipoPessoa: any;
    codCidade: any;
  }): Promise<AxiosResponse> => UDNICK.callService('criaParceiro', { parceiro }),
};

export const TiposRodadoService = {
  getTiposRodado: (): Promise<AxiosResponse> => UDNICK.callService('getTiposRodado', {}),
};

export const getVeiculos = {
  getTipoVeiculos: (): Promise<AxiosResponse> => UDNICK.callService('getTipoVeiculos', {}),
};

export const TiposCarroceriaService = {
  getTiposCarroceria: (): Promise<AxiosResponse> => UDNICK.callService('getTipoVeiculos', {}),
};

export const MarcasVeiculosService = {
  getMarcas: (): Promise<AxiosResponse> => UDNICK.callService('getMarcas', {}),
};

export const ModeloByMarcaService = {
  getModelosByMarca: (codMarca: number | any): Promise<AxiosResponse> =>
    UDNICK.callService('getModelosByMarca', { codMarca }),
};

export const EditarCadVeiculoService = {
  editarVeiculo: (veiculo: {
    codVeiculo: number;
    anoFabricacao: string;
    anoModelo: string;
    tara: number;
    capacidade: number;
    pesoBruto: number;
    cor: string;
  }): Promise<AxiosResponse> => UDNICK.callService('alterarVeiculo', { veiculo }),
};

export const criaMarcaVeiculo = {
  criaMarcaVeiculo: (descricao: { descricao: string }): Promise<AxiosResponse> =>
    UDNICK.callService('criaMarcaVeiculo', { marca: { descricao } }),
};

export const criaModeloVeiculo = {
  criaModeloVeiculo: (
    descricao: { descricao: string },
    codMarca: { codMarca: number }
  ): Promise<AxiosResponse> =>
    UDNICK.callService('criaModeloVeiculo', { modelo: { descricao, codMarca } }),
};
